<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->

		<div class="DateSelectDiv">
			<label>Start Date:</label>
			<p-calendar
				class="DateMargin"
				[disabled]="loading == true"
				[(ngModel)]="StartDate"
				(ngModelChange)="onStartDateChange($event)"
				showIcon="true"
				showButtonBar="true"
			></p-calendar>

			<label class="DateMargin">End Date:</label>
			<p-calendar
				class="DateMargin"
				[disabled]="loading == true"
				[(ngModel)]="EndDate"
				(ngModelChange)="onEndDateChange($event)"
				showIcon="true"
				showButtonBar="true"
			></p-calendar>
		</div>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstEmailLog"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedEmailLog"
		dataKey="EmailLogID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentName-->
				<th>
					<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ExpireDateDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="ExpireDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--c_dateDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="c_dateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--AdminPersonName-->
				<th>
					<p-columnFilter type="text" field="AdminPersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Response-->
				<th>
					<p-columnFilter type="text" field="Response" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SuccessfulDesc-->
				<th>
					<p-columnFilter field="SuccessfulDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSuccessfulDesc
								[ngModel]="value"
								[options]="lstSuccessfulDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="StudentName">Student<p-sortIcon field="StudentName"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<th pSortableColumn="ExpireDate">Expire Date<p-sortIcon field="ExpireDate"></p-sortIcon></th>
				<th pSortableColumn="c_date">Sent Time<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="AdminPersonName">Sent By<p-sortIcon field="AdminPersonName"></p-sortIcon></th>
				<th pSortableColumn="Response">Response<p-sortIcon field="Response"></p-sortIcon></th>
				<th pSortableColumn="SuccessfulDesc">Successful<p-sortIcon field="SuccessfulDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-EmailLog>
			<tr [pSelectableRow]="EmailLog" (dblclick)="onRowDblClick(EmailLog)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ EmailLog[col.field] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="EmailLog.ExpireDateDesc == 'N/A' ? 'Red' : 'Black'"
				>
					{{ EmailLog["ExpireDateDesc"] }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ EmailLog[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="EmailLog.Successful == true ? 'Green' : 'Red'">
					{{ EmailLog["SuccessfulDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
